import axios from 'axios'

// Get all show date expenses
const getAll = async (showDate) => {
  const { data } = await axios.get(`${process.env.VUE_APP_API}/show-expense/${showDate}`)
  return data
}

// Create show date expense
const create = async (
  showDate,
  description,
  value
) => {
  const { data } = await axios.post(`${process.env.VUE_APP_API}/show-expense`, {
    showDate,
    description,
    value
  })
  return data
}

// Update show date expense
const update = async (
  id,
  description,
  value
) => {
  const { data } = await axios.put(`${process.env.VUE_APP_API}/show-expense/${id}`, {
    description,
    value
  })
  return data
}

// Remove show date expense
const remove = async (id, reason) => {
  const { data } = await axios.delete(`${process.env.VUE_APP_API}/show-expense/${id}`)
  return data
}

export {
  getAll,
  create,
  update,
  remove
}
